import { Mark } from "@tiptap/core";

export const CommentMark = Mark.create({
  name: "commentMark",

  addAttributes() {
    return { id: { default: null } };
  },

  parseHTML() {
    return [{ tag: "span[data-comment-id]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      {
        ...HTMLAttributes,
        "data-comment-id": HTMLAttributes.id,
        class: "temporaryComment",
        style: "background-color: orange;"
      },
      0
    ];
  },

  addOptions() {
    return { ...this.parent?.(), spanning: true };
  },

  addMarkOptions() {
    return { ...this.parent?.(), spanning: true, inclusive: true };
  }
});
